import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=530c85e4&lang=pug&"
import script from "./MerchantList.vue?vue&type=script&lang=js&"
export * from "./MerchantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports